module.exports = __webpack_public_path__ + "img/thaw-passengers.a00453ab.jpg";